import React from 'react';
export var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'sans-serif'
    }
  }, children);
};